<mat-form-field appearance="standard">
    <mat-label>{{ label }}
        <span class="form-field__req" *ngIf="required">*</span>
    </mat-label>
    <mat-select [value]="value" [disabled]="isDisabled" (selectionChange)="onChange($event)" (blur)="onBlur()">
        <!-- <mat-label>Choose an option</mat-label> -->
        <mat-option>-- Select Something --</mat-option>
        <mat-option *ngFor="let item of items" [value]="item.partyMaskId || item.cityId || item.provinceId  || item.lookupId || item.departmentId || item.industryId || item.executed || item.templateId || item.businessId || item.taggedUserId">
            {{ item.maskName || item.description || item.name || item.value  || item.userName }}
        </mat-option>
    </mat-select>
</mat-form-field>

<div class="form-field__error" [class.form-field_error]="hasError()">
    <ng-container *ngIf="control && errorKey" [ngSwitch]="errorKey">
        <span *ngSwitchCase="'min'">Minimum {{control?.errors[errorKey].min}}</span>
        <span *ngSwitchCase="'max'">Maximum {{control?.errors[errorKey].max}}</span>
        <span *ngSwitchCase="'required'">This field is <strong>required</strong></span>
        <span *ngSwitchCase="'requiredtrue'">This field is <strong>required</strong></span>
        <span *ngSwitchCase="'minlength'">At least {{control?.errors[errorKey].requiredLength}} character</span>
        <span *ngSwitchCase="'maxlength'">No more than {{control?.errors[errorKey].requiredLength}} character</span>
        <span *ngSwitchCase="'pattern'">
            <span *ngIf="patternError">{{patternError}}</span>
        <span *ngIf="!patternError">Pattern dose not match</span>
        </span>
        <span *ngSwitchCase="'min'"></span>
    </ng-container>
</div>
